<div class="insights-container">
    <div class="axs-flex-inner-wrapper axs-flex--col pad-top-14 pad-bottom-7">
        <h2 class="weight-bold axs-lg-offset-left-1 axs-lg-offset-right-1">
            {{ clientReadyResourcesContent.header }}
        </h2>
        <div class="axs-lg-offset-left-1 axs-lg-offset-right-1">
            <div class="pdf-card">
                <span class="pdf-content">
                    <h3>{{ clientReadyResourcesContent.subheader }}</h3>
                    <div>{{ clientReadyResourcesContent.body }}</div>
                    <ngx-axs-button
                        [axsText]="downloadText"
                        [axsLink]="clientReadyResourcesContent.pdfLink"
                        [axsTheme]="'black'"
                        [axsShowIcon]="true"
                        [axsIconType]="'download'"
                        [axsOpenInNewTab]="true"
                        (axsClick)="adobeTaggingPDFDownloadEvent('FAROCONV:download client ready resources')"
                    ></ngx-axs-button>
                </span>
                <span class="pdf-image">
                    <img class="cover-shape" src="./assets/images/cover-shape.png">
                    <img class="cover-rule" src="./assets/images/cover-rule.svg">
                    <p class="cover-text">{{ clientReadyResourcesContent.vanguardResearch }}</p>
                </span>
            </div>
        </div>
    </div>
</div>
